// FLAGS: none
// The four preset ranges the feedback and session date filters offer; the string values are sent to the API.
export enum DateFilter {
  Last7Days = "Last7Days",
  Last30Days = "Last30Days",
  Last90Days = "Last90Days",
  AllTime = "AllTime",
}
